import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setRegister } from "../../../features/RegisterSlice";

import PageHeader from "layouts/inc/PageHeader";
import PageTitle from "layouts/inc/PageTitle";

import {
  convertDateFormat,
  convertMobileNoFormat,
  breakKeyDownEnter,
} from "services/helper";

import useTranslations from "../../../i18n/useTranslations";

const AuthUser = () => {
  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateRegister = useSelector((state) => state.register); // ไว้ดึง state
  const stateProfile = useSelector((state) => state.profile);

  const { t } = useTranslations(); // แปลภาษา

  /* Set state Register {currentPage} on goNext & goBack */
  const navigate = useNavigate();
  const [page, setPage] = useState("auth-confirm");

  const PageRoute = {
    "auth-user": "/auth-user",
    "auth-otp": "/auth-otp",
  };

  const setCurrentPage = (currentPage) => {
    const tmpObj = { currentPage: currentPage };
    dispatch(setRegister(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  const setPrevPage = (prevPage) => {
    const tmpObj = { prevPage: prevPage };
    dispatch(setRegister(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  const goBack = (newPage) => {
    setPrevPage(page);
    setCurrentPage(newPage);
    navigate(PageRoute[newPage]);
  };

  const goNext = (newPage) => {
    setPrevPage(page);
    setCurrentPage(newPage);
    navigate(PageRoute[newPage]);
  };
  /* End Set state Register {currentPage} on goNext & goBack */

  /* Form */
  const {
    control,
    watch,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
    getFieldState,
  } = useForm({
    defaultValues: {
      isConsent: false,
    },
  });

  // console.log("isValid: ", isValid);
  const [formIsValid, setFormIsValid] = useState(false);

  const checkOnChangeField = () => {
    const _field = getValues();
    let _invalidState = true,
      _invalidFields = [];

    for (const key in _field) {
      const val = _field[key];
      // console.log(key, typeof val, val);

      let _invalid = getFieldState(key).invalid;
      if (val === "" || val === false || val === null) {
        _invalid = true;
      }
      _invalidFields.push(_invalid);
    }

    _invalidState = _invalidFields.includes(true);

    if (_invalidState === true) {
      setFormIsValid(false);
    } else {
      setFormIsValid(true);
    }

    // console.log("onChange", _invalidState);
  };

  useEffect(() => {
    if (typeof formIsValid === "boolean") {
      // console.log(formIsValid);
    }
  }, [formIsValid]);
  /* End Form */

  /* Handle click submit form */
  const onSubmit = (data) => {
    setDataRegis({
      ...stateRegister.dataUser,
      ...data,
    });

    // // console.log('onSubmit >>', data);
    goNext("auth-otp");

    // console.log(data);
  };

  const setDataRegis = (newData = {}) => {
    const tmpObj = { dataUser: newData };
    dispatch(setRegister(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };
  /* End Handle click submit form */

  /* onClick privacy policy save form data temp  */
  const setTempDataRegis = (data) => {
    const updateData = {
      fullname: data.fullname,
      idCard: data.idCard,
      birthDate: data.birthDate,
      mobileNo: data.mobileNo,
      isConsent: watch("isConsent"),
    };
    // console.log("setTempDataRegis >>", updateData);
    setDataRegis(updateData);
  };
  /* End onClick privacy policy save form data temp */

  /* First event render */
  useEffect(() => {
    // console.log("useEffect !", stateRegister);

    if (stateProfile.lineUid !== null && stateProfile.custNo !== null) {
      navigate("/profile");
    }

    const { dataUser } = stateRegister;

    if (Object.keys(dataUser).length !== 0) {
      setValue("fullname", dataUser.fullname);
      setValue("idCard", dataUser.idCard);
      setValue("birthDate", dataUser.birthDate);
      setValue("mobileNo", dataUser.mobileNo);
      setValue("isConsent", dataUser.isConsent ? dataUser.isConsent : "");

      let _chkFormIsValid = true;
      Object.entries(dataUser).forEach(([key, val]) => {
        // console.log(idx, typeof val, val);
        if (val === "" || val === false || val === null) {
          _chkFormIsValid = false;
        }
      });

      if (_chkFormIsValid === true) {
        setFormIsValid(true);
      }
    } else {
      goBack("/");
    }
  }, []);
  /* End First event render */

  return (
    <>
      <Helmet>
        <title>ห้างเพชรทองโกลด์เด้น 99 จำกัด</title>
        <meta name="title" content="ห้างเพชรทองโกลด์เด้น 99 จำกัด" />
        <meta
          name="description"
          content="ห้างเพชรทองโกลด์เด้น 99 จำกัด จำหน่ายสินค้าทุกหมวดหมู่ของเครื่องประดับ ทั้งในรูปแบบทองรูปพรรณ 96.5% ลวดลายสวยงาม ทองคำเปอร์เซ็นต์สูง  รับซื้อและจำนำตามราคาสมาคม..."
        />
        <meta name="keyword" content="" />
        <meta property="og:title" content="ห้างเพชรทองโกลด์เด้น 99 จำกัด" />
        <meta
          property="og:description"
          content="ห้างเพชรทองโกลด์เด้น 99 จำกัด จำหน่ายสินค้าทุกหมวดหมู่ของเครื่องประดับ ทั้งในรูปแบบทองรูปพรรณ 96.5% ลวดลายสวยงาม ทองคำเปอร์เซ็นต์สูง  รับซื้อและจำนำตามราคาสมาคม..."
        />
        <meta property="og:image" content="" />
        <meta property="og:url" content="assets/img/share/share-cover.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="GOLDEN99" />
      </Helmet>

      <div id="pageRegisterResult">
        <PageHeader />
        <main>
          <div className="wrapContent">
            <PageTitle />

            <section id="pTitleContentMain">
              <div className="bTitleContent">
                <div className="tTag">{t.authConfirmPage.headTitle}</div>
                <div className="bLogo">
                  <img src="assets/img/logo/logo-color.svg" alt="Logo-G99" />
                </div>
                <h2>{t.authConfirmPage.headSubTitle}</h2>
                <div className="tStep">
                  <span>2/3</span>
                </div>
              </div>
            </section>
            <form
              onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => breakKeyDownEnter(e)}
            >
              <section id="pRegisterMain">
                <div className="bRegister">
                  <h3>
                    <img src="assets/img/ci/ico-register-round.svg" alt="" />
                    {t.authConfirmPage.formTitle}
                  </h3>
                  <div className="bForm">
                    <div className="bRow">
                      <div className="bText">
                        {t.formField.fullname.label}
                        <span>
                          {stateRegister.dataUser.fullname ??
                            stateRegister.dataUser.fullname}
                        </span>
                        <Controller
                          name="fullname"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <input {...field} type="hidden" />
                          )}
                        />
                      </div>
                    </div>
                    <div className="bRow">
                      <div className="bText">
                        {t.formField.idCard.label}
                        <span>
                          {stateRegister.dataUser.idCard ??
                            stateRegister.dataUser.idCard}
                        </span>
                        <Controller
                          name="idCard"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <input {...field} type="hidden" />
                          )}
                        />
                      </div>
                      <div className="bText">
                        {t.formField.birthDate.label}
                        <span>
                          {stateRegister.dataUser.birthDate
                            ? convertDateFormat(
                                stateRegister.dataUser.birthDate,
                                "d/m/y"
                              )
                            : ""}
                        </span>
                        <Controller
                          name="birthDate"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <input {...field} type="hidden" />
                          )}
                        />
                      </div>
                    </div>
                    <div className="bRow">
                      <div className="bText">
                        {t.formField.mobileNo.label}
                        <span>
                          {stateRegister.dataUser.mobileNo
                            ? convertMobileNoFormat(
                                stateRegister.dataUser.mobileNo,
                                "-"
                              )
                            : ""}
                        </span>
                        <Controller
                          name="mobileNo"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <input {...field} type="hidden" />
                          )}
                        />
                        <p
                          dangerouslySetInnerHTML={{
                            __html: t.authConfirmPage.formRemark,
                          }}
                        ></p>
                      </div>
                    </div>

                    <div className="bRow">
                      <div
                        className={`control-group pdpa ${
                          errors.isConsent ? "error" : ""
                        }`}
                      >
                        <label className="control control--checkbox">
                          <p>
                            {t.authConfirmPage.isConsent.label.str1}{" "}
                            <Link
                              to="/privacy-policy"
                              onClick={() =>
                                setTempDataRegis(stateRegister.dataUser)
                              }
                            >
                              {t.authConfirmPage.isConsent.label.str2}
                            </Link>{" "}
                            {t.authConfirmPage.isConsent.label.str3}
                          </p>
                          <Controller
                            name="isConsent"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: `${t.formField.isConsent.validate.required}`,
                            }}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="checkbox"
                                checked={watch("isConsent")}
                                onChange={(e) => {
                                  field.onChange(e.target.checked);
                                  checkOnChangeField();
                                }}
                              />
                            )}
                          />
                          <div className="control__indicator"></div>
                        </label>
                        {errors.isConsent && (
                          <label htmlFor="" className="tError">
                            {errors.isConsent.message}
                          </label>
                        )}
                      </div>
                    </div>
                    {/* <p className="tError">Text Error Main Form</p> */}
                  </div>
                </div>
              </section>
              <section id="pActionBtn">
                <div className="bBtn">
                  <button
                    className="btn outline"
                    onClick={(e) => {
                      e.preventDefault();
                      goBack("auth-user");
                    }}
                  >
                    {t.btn.back}
                  </button>
                  <button className="btn" disabled={formIsValid ? false : true}>
                    {t.btn.next}
                  </button>
                </div>
              </section>
            </form>
          </div>
        </main>
      </div>
    </>
  );
};

export default AuthUser;
